module.exports = __webpack_public_path__ + "assets/img/54.7bf00034.png";